import React from 'react';
import InfoButton from './InfoButton';

function PasswordSettings({
  passwordLength,
  setPasswordLength,
  passwordType,
  setPasswordType,
  includeCapital,
  setIncludeCapital,
  includeLowercase,
  setIncludeLowercase,
  includeNumbers,
  setIncludeNumbers,
  includeSymbols,
  setIncludeSymbols,
  onGeneratePassword,
  password,
}) {
  const copyPassword = () => {
    navigator.clipboard.writeText(password);
    alert('Password copied to clipboard!');
  };

  return (
    <div className="password-settings">
      <h2 className="settings-title">Password Settings</h2>
      <hr />
      <div className="settings-row">
        <div className="length-setting">
          <label htmlFor="password-length">Password length</label>
          <input
            type="number"
            id="password-length"
            min="1"
            max="50"
            value={passwordLength}
            onChange={(e) => setPasswordLength(Number(e.target.value))}
          />
          <input
            type="range"
            min="1"
            max="50"
            value={passwordLength}
            onChange={(e) => setPasswordLength(Number(e.target.value))}
          />
        </div>
        <div className="type-setting">
          <div>
            <input
              type="radio"
              id="easy-pronounce"
              name="password-type"
              value="pronounce"
              checked={passwordType === 'pronounce'}
              onChange={() => setPasswordType('pronounce')}
            />
            <label htmlFor="easy-pronounce">Easy to pronounce</label>
            <InfoButton tooltip="Avoid numbers and special characters" />
          </div>
          <div>
            <input
              type="radio"
              id="easy-read"
              name="password-type"
              value="read"
              checked={passwordType === 'read'}
              onChange={() => setPasswordType('read')}
            />
            <label htmlFor="easy-read">Easy to read</label>
            <InfoButton tooltip="Avoid ambiguous characters such as l, 1, 0 and O" />
          </div>
          <div>
            <input
              type="radio"
              id="all-signs"
              name="password-type"
              value="all"
              checked={passwordType === 'all'}
              onChange={() => setPasswordType('all')}
            />
            <label htmlFor="all-signs">All signs</label>
            <InfoButton 
              tooltip={
                <>
                  <span className="tooltip-full">Includes uppercase, lowercase, numbers, and symbols</span>
                  <span className="tooltip-short">A-Z, a-z, 0-9, symbols</span>
                </>
              } 
              className="all-signs-info" 
            />
          </div>
        </div>
        <div className="include-setting">
          <div>
            <input
              type="checkbox"
              id="include-capital"
              checked={includeCapital}
              onChange={() => setIncludeCapital(!includeCapital)}
            />
            <label htmlFor="include-capital">Capital letters</label>
          </div>
          <div>
            <input
              type="checkbox"
              id="include-lowercase"
              checked={includeLowercase}
              onChange={() => setIncludeLowercase(!includeLowercase)}
            />
            <label htmlFor="include-lowercase">Lowercase letters</label>
          </div>
          <div>
            <input
              type="checkbox"
              id="include-numbers"
              checked={includeNumbers}
              onChange={() => setIncludeNumbers(!includeNumbers)}
            />
            <label htmlFor="include-numbers">Numbers</label>
          </div>
          <div>
            <input
              type="checkbox"
              id="include-symbols"
              checked={includeSymbols}
              onChange={() => setIncludeSymbols(!includeSymbols)}
            />
            <label htmlFor="include-symbols">Symbols</label>
          </div>
        </div>
      </div>
      <p className="disclaimer">
        This web app does not retain or memorize any passwords generated. Make sure you are generating your password in a secure environment.
      </p>
      <div className="button-container">
        <button className="action-button" onClick={onGeneratePassword}>
          Generate Password
        </button>
        <button className="action-button" onClick={copyPassword}>
          Copy Password
        </button>
      </div>
    </div>
  );
}

export default PasswordSettings;